import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { Alert } from "@material-ui/lab";
import { FC, ReactNode, useEffect, useState } from "react";
import { Formater, TypeRecords } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { InputComboBoxList } from "src/framework/components/forms";
import theme from "src/theme/light";
import { FinanceiraType, FinanciamentoParcela, FinanciamentoSimulacao, Simulacao } from "src/types";
import { AVISO_ENTRADA_FINANCIAMENTO } from "../constants";

export interface FinanciamentosGridProperties {
    simulacao: Simulacao;
    simulacoes: FinanciamentoSimulacao[];
    financeiras: FinanceiraType[];
    financeirasHabilitadas: number[];
    onChange: (simulacao: FinanciamentoSimulacao | null, financeira: FinanceiraType | null, parcela: FinanciamentoParcela | null) => void;
}

interface ParcelaSelecionada {
    idxFinanceira: string;
    idxParcela: string;
    state: FinanciamentoParcela | null
}

interface FinanceiraIdxResult {
    [id: string]: ParcelaSelecionada
}

const FinanciamentosGrid: FC<FinanciamentosGridProperties> = ({
    simulacao,
    simulacoes,
    financeiras,
    financeirasHabilitadas = [],
    onChange,
}) => {

    const [financeiraXID, setFinanceiraXID] = useState<FinanceiraIdxResult>({});
    const [financeiraSelecionada, setFinanceiraSelecionada] = useState<FinanceiraType | null>(null);
    const [checked, setChecked] = useState<string>("");

    const builder = (financeiras: FinanceiraType[], render: (financeiras: any[]) => ReactNode): ReactNode => {
        return render(financeiras)
    }

    useEffect(() => {
        for (const idx in simulacoes) {
            if (financeiraXID && simulacoes && simulacoes[idx] !== null && simulacoes[idx] !== undefined) {

                const parcelaDesejada = simulacoes[idx]?.parcelas?.find((_p) => _p.parcela === simulacao?.parcelas) || null
                const idxParcelaDesejada = String(simulacoes[idx]?.parcelas?.findIndex((_p) => _p.parcela === simulacao?.parcelas))

                financeiraXID[String(simulacoes[idx].financeira_id)] = {
                    idxFinanceira: idx,
                    idxParcela: idxParcelaDesejada,
                    state: parcelaDesejada
                }
            }
        }

        setFinanceiraXID({ ...financeiraXID })
    }, [simulacoes]);

    return (
        <div className="FinanciamentosGrid">
            <div className="row">
                <div className="X12">
                    <Paper style={{ marginTop: "14px", marginBottom: "14px" }} >
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={30} style={{ background: theme.palette.background.default }}></TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {
                                                return <><TableCell align="center" key={`${financeira.nome}-header-${index}`} padding="checkbox" width={30}
                                                    style={{
                                                        background: theme.palette.background.default,
                                                        borderTop: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >

                                                    <strong style={{ color: !financeirasHabilitadas.includes(financeira.id) || simulacoes.length === 0 || !simulacoes?.find((s) => s?.financeira_id === financeira.id) || financeiraXID[financeira.id]?.idxParcela === String(-1) ? theme.palette.action.disabled : theme.palette.common.black }}>{financeira?.nome}</strong>
                                                </TableCell></>
                                            })
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Parcelas</strong>
                                        </TableCell>

                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {
                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell style={{ textAlign: 'center' }} key={`${financeira.nome}-parcelas-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id)

                                                const parcelas = simulacoes[_financieraIdx]?.parcelas

                                                return <TableCell key={`${financeira.nome}-parcelas-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >
                                                    <InputComboBoxList
                                                        options={parcelas || []}
                                                        textField="parcelas"
                                                        valueField="parcela"
                                                        value={financeiraXID[financeira.id].state}
                                                        renderOptions={(option: FinanciamentoParcela) => {
                                                            return `${option.parcela}x de ${Formater.toString(option.valor_parcela, TypeRecords.CURRENCY)}`
                                                        }}
                                                        renderOptionsLabel={(option) => {
                                                            return `${option.parcela}x`
                                                        }}
                                                        onChange={(_parcela, _index) => {
                                                            financeiraXID[financeira.id].state = _parcela || null
                                                            financeiraXID[financeira.id].idxFinanceira = String(index)
                                                            financeiraXID[financeira.id].idxParcela = String(_index)

                                                            setFinanceiraXID({ ...financeiraXID });
                                                            setFinanceiraSelecionada(null)
                                                            setChecked("")
                                                            onChange(null, null, null);
                                                        }}
                                                    />
                                                </TableCell>
                                            })
                                        })}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Situação</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                let situacao = !financeirasHabilitadas.includes(financeira.id) ? "Não habilitado" : " - ";
                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id);

                                                if (_financieraIdx > -1) {
                                                    if (simulacoes[_financieraIdx].mensagem && simulacoes[_financieraIdx].mensagem.length) {
                                                        situacao = simulacoes[_financieraIdx].mensagem[0];
                                                    } else {
                                                        if (simulacoes[_financieraIdx].total_liberado > 0) {
                                                            situacao = "Pré-aprovado";
                                                        }
                                                    }
                                                }

                                                return <TableCell align="center" key={`${financeira.nome}-situacao-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >{situacao}</TableCell>
                                            })
                                        })}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Entrada*</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-entrada-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id);

                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-entrada-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    key={`${financeira.nome}-entrada-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >{Formater.toString(simulacoes[_financieraIdx]?.parcelas[Number(financeiraXID[financeira.id].idxParcela)]?.valor_entrada, TypeRecords.CURRENCY)}</TableCell>
                                            })
                                        })}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Valor parcela</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-parcela-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id)

                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-parcela-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    key={`${financeira.nome}-entrada-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >{Formater.toString(simulacoes[_financieraIdx]?.parcelas[Number(financeiraXID[financeira.id].idxParcela)]?.valor_parcela, TypeRecords.CURRENCY)}</TableCell>
                                            })
                                        })}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Taxa</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-taxa-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id)

                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-taxa-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",

                                                    }}
                                                >{Formater.toString(simulacoes[_financieraIdx]?.parcelas[Number(financeiraXID[financeira.id].idxParcela)]?.taxa_juros || 0.0, TypeRecords.PERCENT2)} a.m.
                                                </TableCell>
                                            })
                                        })}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Carência 1º Pagamento</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-carencia-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id);
                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-carencia-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    key={`${financeira.nome}-carencia-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >{simulacoes[_financieraIdx]?.parcelas[Number(financeiraXID[financeira.id].idxParcela)]?.dias_carencia_primeiro_pagamento || 0} dias</TableCell>
                                            })
                                        })}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component={"th"} style={{ background: theme.palette.background.default }}>
                                            <strong>Valor financiado</strong>
                                        </TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-financiado-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id);
                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-financiado-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    key={`${financeira.nome}-valor-financiado-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >{Formater.toString(simulacoes[_financieraIdx]?.total_liberado, TypeRecords.CURRENCY)}</TableCell>
                                            })
                                        })}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell component={"th"}></TableCell>
                                        {builder(financeiras, (financeiras): ReactNode => {
                                            return financeiras?.map((financeira: any, index: number) => {

                                                if (!financeiraXID[financeira.id]) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-financiado-${index}`}> - </TableCell>
                                                }

                                                const _financieraIdx = simulacoes.findIndex((s) => s.financeira_id === financeira.id)

                                                if (_financieraIdx === -1 || !simulacoes[_financieraIdx]?.parcelas || !simulacoes[_financieraIdx]?.parcelas.length) {
                                                    return <TableCell align="center" key={`${financeira.nome}-valor-financiado-${index}`}> - </TableCell>
                                                }

                                                return <TableCell align="center"
                                                    key={`${financeira.nome}-valor-acao-${index}`}
                                                    style={{
                                                        borderLeft: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderRight: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                        borderBottom: financeiraSelecionada?.id === financeira.id ? `2px dotted ${green[500]}` : "inherit",
                                                    }}
                                                >
                                                    <FullWidthButton
                                                        color={"primary"}
                                                        variant={checked === financeira.id ? "contained" : "outlined"}
                                                        disableElevation
                                                        text="Selecionar"
                                                        size="small"
                                                        disabled={!financeirasHabilitadas.includes(financeira.id) || simulacoes.length === 0 || !simulacoes?.find((s) => s?.financeira_id === financeira.id) || financeiraXID[financeira.id]?.idxParcela === String(-1)}
                                                        onClick={() => {
                                                            const checkedState = checked;
                                                            const newCheckedState = checkedState === financeira.id ? "" : financeira.id

                                                            const _checked: boolean = newCheckedState === financeira.id;


                                                            let _simulacao: FinanciamentoSimulacao | null = null
                                                            let _financeira: FinanceiraType | null = null
                                                            let _parcela: FinanciamentoParcela | null = null

                                                            if (_checked) {
                                                                _parcela = simulacoes[_financieraIdx]?.parcelas[Number(financeiraXID[financeira.id].idxParcela)];
                                                                _financeira = financeira;

                                                                _simulacao = simulacoes?.find((_s) => _s.financeira_id === financeira.id) || null

                                                            }

                                                            setFinanceiraSelecionada(_checked ? financeira : null);
                                                            setChecked(newCheckedState)
                                                            onChange(_simulacao, _financeira, _parcela);
                                                        }}
                                                    />
                                                </TableCell>
                                            })
                                        })}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </div>
            </div>
            <div className="row" style={ { paddingBottom: "5px" } }>
                <div className="X12">
                    <Alert severity="warning">
                        {AVISO_ENTRADA_FINANCIAMENTO}
                    </Alert>
                </div>
            </div>
        </div>
    )
}

export { FinanciamentosGrid }